import { mdiTownHall } from '@mdi/js'

export default {
  title: 'Fund',
  to: 'school-fund-list',
  icon: mdiTownHall,
  action: 'read',
  resource: 'FundHeadMaster',
}
